import { faArrowDown, faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useMemo, useState } from 'react'
import { useTable } from 'react-table';
import { capitalizeFirstLetters } from '../../features/ValueFormater';
import Table from '../../components/Table';
import { useDispatch, useSelector } from 'react-redux';
import { setTodoActiveButton } from '../../features/TodoSlice';
import useTodoApi from '../../api/TodoApi';
import UtcToLocal from '../../components/UtcToLocal';
import TransferListSkeleton from '../../components/skeletons/TransferListSkeleton';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ViewQr from '../../components/ViewQr';
import TransactionDetailsSkeleton from '../../components/skeletons/TransactionDetailsSkeleton';

function OrderTable() {

    const [activeRowIndex, setActiveRowIndex] = useState();
    const [searchQuery, setSearchQuery] = useState("");
    const [isQrVisible, setIsQrVisible] = useState(false);
    const [selectedOrderID, setSelectedOrderID] = useState(null);
    const [loading, setLoading] = useState(false);

    const disptach = useDispatch();
    const { GetOrdersToProcess, GetOrder, GetOrderQr, isLoading } = useTodoApi();
    const ordersTodo = useSelector(state => state.todo.ordersToDo);



    useEffect(() => {
        GetOrdersToProcess();
    }, [])

    // useEffect(() => {
    //     GetOrdersToProcess();

    //     const groupName = "Employee";

    //     const webSocket = new WebPubSubClient("wss://suyooluat.webpubsub.azure.com/client/hubs/CashPickUPPortal?access_token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjpbIndlYnB1YnN1Yi5qb2luTGVhdmVHcm91cC5FbXBsb3llZSIsIndlYnB1YnN1Yi5zZW5kVG9Hcm91cC5FbXBsb3llZSJdLCJuYmYiOjE3Mjk1OTU2MTQsImV4cCI6MTcyOTU5OTIxNCwiaWF0IjoxNzI5NTk1NjE0LCJhdWQiOiJodHRwczovL3N1eW9vbHVhdC53ZWJwdWJzdWIuYXp1cmUuY29tL2NsaWVudC9odWJzL0Nhc2hQaWNrVVBQb3J0YWwifQ.TU_CU3oZ9IsLlYwhBN0J5g352pmjK6njjgx5akalLbk");

    //     webSocket.on("connected", () => {
    //         console.log("WebSocket connected");

    //         webSocket.joinGroup(groupName)
    //             .then(() => {
    //                 console.log(`Joined group: ${groupName}`);

    //                 webSocket.sendToGroup("Employee", "Testing, Hi Georges", "text").then(() => {
    //                     console.log("Sent message");
    //                  })
    //                     .catch((error) => {
    //                         console.error("Failed to send message to group:", error);
    //                     });
    //             })
    //             .catch((error) => {
    //                 console.error("Failed to join group:", error);
    //             });
    //         GetOrdersToProcess();
    //     });

    //     webSocket.on("group-message", (message) => {
    //         toast.info(`New Notification: ${JSON.stringify(message)}`);
    //         console.log("Message received:", message);
    //     });

    //     webSocket.on("disconnected", () => {
    //         console.log("WebSocket disconnected");
    //     });

    //     webSocket.on("error", (error) => {
    //         console.error("WebSocket error:", error);
    //         toast.error(`WebSocket Error: ${error.message}`);
    //     });

    //     webSocket.start()
    //         .then(() => {
    //             console.log("WebSocket client started");
    //         })
    //         .catch((err) => {
    //             console.error("Error starting WebSocket client:", err);
    //         });


    //     return () => {
    //         webSocket.stop();
    //     };
    // }, []);


    const options = {
        weekday: 'short',
        day: 'numeric',
        month: 'short',
        year: 'numeric'
    };

    const handlePrepare = (orderID) => {
        disptach(setTodoActiveButton({ name: "OrderToPrepare" }))
        GetOrder(orderID);
    }

    const handleViewQr = async (orderID) => {
        setSelectedOrderID(orderID);
        setLoading(true); 
        setIsQrVisible(true);
        
        try {
            await GetOrderQr(orderID);
        } finally {
            setLoading(false); 
        }
    };

    const columns = useMemo(() => [
        {
            Header: "Order ID",
            accessor: "orderID",
        },
        {
            Header: "Currency",
            accessor: "currency",
        },
        {
            Header: "",
            accessor: "details",
            Cell: ({ row }) => (
                <button className="showmore" onClick={() => setActiveRowIndex(row.index)}>
                    <FontAwesomeIcon icon={faArrowDown} />
                </button>
            ),
        },
        {
            Header: "Date",
            accessor: "date",
            Cell: ({ cell: { value } }) => {
                return <UtcToLocal utcTimestamp={value} options={options} />
            },
        },
        {
            Header: "Driver Name",
            accessor: "driverName",
        },
        {
            Header: "Time",
            id: "time",
            accessor: "date",
            Cell: ({ cell: { value } }) => {
                const date = new Date(value);
                return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
            },
        },
        {
            Header: "Status",
            accessor: "status",
            Cell: ({ cell: { value } }) => {
                if (["new", "out of delivery", "cancelled by client"].includes(value.toLowerCase())) {
                    return <div className={"status " + value?.toUpperCase()}>{capitalizeFirstLetters(value)}</div>
                }
            }
        },
        {
            Header: "",
            accessor: "others",
            Cell: ({ row }) => {
                if (row.original.orderStep === "set-billreference" || row.original.orderStep === "scanQr") {
                    return (
                        <button className='prepare-btn' onClick={() => handlePrepare(row.original.orderID)}>
                            Continue Preparing
                        </button>
                    );
                }
                 else if (row.original.orderStep === "confirmed") {
                    return (
                        <button className='prepare-btn' onClick={() => handleViewQr(row.original.orderID)}>
                            View QR
                        </button>
                    );
                } 
                else {
                    return (
                        <button className='prepare-btn' onClick={() => handlePrepare(row.original.orderID)}>
                            Prepare
                        </button>
                    );
                }
            },
        }
    ], []);

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
    } = useTable({ columns, data: ordersTodo });

    const filteredRows = rows.filter((row) => {
        return Object.values(row.original).some((cellValue) => {
            return cellValue && cellValue.toString().toLowerCase().includes(searchQuery.toLowerCase());
        });
    });

    return (
        <>
            <ToastContainer
                autoClose={false}
                closeOnClick={false}
                hideProgressBar={true}
            />
            <div className='OrderTable'>
                <div className='OrderID'>
                    <img src="/Images/NewOrders.svg" />
                    <div className='numberID'>New Orders</div>
                </div>
                <div className='OrderTableContainer'>
                    <div className="table-container">
                        <div className="tableTop">
                            <div className="filtering">
                                <div className="filteringSearch">
                                    <input
                                        className="search"
                                        placeholder="Search"
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)} />
                                    <span className="iconSearch"><FontAwesomeIcon icon={faMagnifyingGlass} /></span>
                                </div>
                            </div>
                        </div>
                        {isLoading ? (
                            <TransferListSkeleton />
                        ) : (
                            <Table
                                headerGroups={headerGroups}
                                page={filteredRows}
                                prepareRow={prepareRow}
                                getTableProps={getTableProps}
                                getTableBodyProps={getTableBodyProps}
                                activeRowIndex={activeRowIndex}
                                setActiveRowIndex={setActiveRowIndex}
                            />
                        )}

                    </div>
                </div>
            </div>
            {isQrVisible && (
                loading ? (
                    <TransactionDetailsSkeleton />
                ) : (
                    <ViewQr
                        orderID={selectedOrderID}
                        onClose={() => setIsQrVisible(false)}
                    />
                )
            )}
        </>
    )
}

export default OrderTable;